import React, { useEffect, useState } from 'react';

function useFocus(inputRef: React.RefObject<HTMLInputElement>) {
  const [hasFocus, setFocus] = useState(false);

  useEffect(() => {
    if (document.hasFocus() && inputRef.current?.contains(document.activeElement)) {
      setFocus(true);
    }
  }, [inputRef]);

  return {
    hasFocus,
    onBlur: () => setFocus(false),
    onFocus: () => setFocus(true),
    setFocus,
  };
}

export default useFocus;
